// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Mt-z","tooltipWrapper":"Nt-z","icon":"Ot-z","tooltip":"Pt-z","content":"Qt-z"};